import { connect } from 'react-redux';
import JumlahSiswaKls from '../../../views/Student/report/JumlahSiswaKls.student.view';
import {
  getParamOptionsAcademics, getClassesOptions, getPeriodsOptions, getPrmLevels, getSchoolUnitsOptions, getParamPerwakilan,
} from '../../../states/thunks/options.thunk';
import {
  listStudentCountClass, studentCount, listStudentCountUnits, listStudentCountPerwakilan,
} from '../../../states/thunks/academics.thunk';


function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    levels: state.options.levels,
    user: state.user || {},

  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleStudentCount: payload => dispatch(studentCount(payload)),
    getClassesOptions: payload => dispatch(getClassesOptions(payload)),
    getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
    handleListStudentCountClass: (payload, goback) => dispatch(listStudentCountClass(payload, goback)),
    handleListStudentCountUnits: (payload, goback) => dispatch(listStudentCountUnits(payload, goback)),
    handleListStudentCountPerwakilan: (payload, goback) => dispatch(listStudentCountPerwakilan(payload, goback)),
    getPeriodsOptions: payload => dispatch(getPeriodsOptions(payload)),
    getPrmLevels: payload => dispatch(getPrmLevels(payload)),
    getSchoolUnitsOptions: payload => dispatch(getSchoolUnitsOptions(payload)),
    getParamPerwakilan: payload => dispatch(getParamPerwakilan(payload)),

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(JumlahSiswaKls);
